import React, {Component} from 'react'
import {FormattedMessage} from 'react-intl'

class PriceListStatusBadge extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            status: this.props.status || '',
            style: this.props.style || {},
        }
        this.className = this.props.className || ''
    }
    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            status: nextProps.status || '',
            style: nextProps.style || {},
        })
    }

    renderStatus(isDisabled) {
        if (isDisabled) {
            return (
                <div className="badge badge-danger text-with-icon">
                    <FormattedMessage
                        id="price_list.status.active_label"
                        defaultMessage="Active"
                    />
                    &nbsp;|&nbsp;
                    <FormattedMessage
                        id="price_list.status.disaled_label"
                        defaultMessage="Disabled by rules"
                    />
                </div>
            )
        }

        switch (this.state.status) {
            case 'draft':
                return <div className="badge badge-primary text-with-icon">
                    <FormattedMessage
                        id="price_list.status.draft_label"
                        defaultMessage="Draft"
                    />
                </div>
            case 'active':
                return <div className="badge badge-success text-with-icon">
                    <FormattedMessage
                        id="price_list.status.active_label"
                        defaultMessage="Active"
                    />
                </div>
            case 'inactive':
                return <div className="badge badge-secondary text-with-icon">
                    <FormattedMessage
                        id="price_list.status.inactive_label"
                        defaultMessage="Inactive"
                    />
                </div>
            case 'disabled':
                return <div className="badge badge-secondary text-with-icon">
                    <FormattedMessage
                        id="price_list.status.disabled_label"
                        defaultMessage="Not available"
                    />
                </div>
            case 'completed':
                return <div className="badge custom-btn-secondary text-with-icon">
                    <FormattedMessage
                        id="price_list.status.completed_label"
                        defaultMessage="Completed"
                    />
                </div>
            }
        return <div />
    }

    render() {
        const {isDisabled} = this.props
        return <span className={this.className} style={this.state.style}>
            {this.renderStatus(isDisabled)}
        </span>
    }

}

export default PriceListStatusBadge





// WEBPACK FOOTER //
// ./src/price-list/status.component.jsx